const RemoveIcon = ({ size = 20, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ backdropFilter: "blur(13.100000381469727px)", ...props.style }}
      {...props}
    >
      <path
        d="M53.1037 16.0708L46.4983 15.301L46.7182 13.4139C46.9586 11.3298 45.467 9.44465 43.3838 9.19943L35.8347 8.31964C33.751 8.07926 31.8658 9.57091 31.6205 11.6544L31.4006 13.5415L24.7951 12.7717C24.545 12.7425 24.2932 12.8137 24.0957 12.97C23.8977 13.1266 23.7706 13.3549 23.7414 13.6054L23.5215 15.4926C23.4923 15.7428 23.5635 15.9945 23.7202 16.1921C23.8765 16.39 24.1051 16.5171 24.3553 16.5463L52.6638 19.8454C52.914 19.8745 53.1657 19.8034 53.3633 19.6467C53.5612 19.4904 53.6884 19.2618 53.7175 19.0116L53.9375 17.1245C53.9666 16.874 53.8954 16.6226 53.7388 16.4247C53.5825 16.2271 53.3539 16.1 53.1037 16.0708ZM44.6111 15.0811L33.2877 13.7614L33.5076 11.8743C33.6301 10.8326 34.5727 10.0864 35.6147 10.2068L43.1639 11.0865C44.2057 11.209 44.9514 12.1519 44.8311 13.1939L44.6111 15.0811Z"
        fill="#CA2C26"
      />
      <path
        d="M22.4398 41.1898C22.1994 43.2738 23.6911 45.159 25.7742 45.4043L44.6468 47.6037C46.7305 47.8441 48.6157 46.3524 48.8609 44.2689L51.5002 21.6221L25.0791 18.543L22.4398 41.1898ZM42.2378 27.2378C42.2986 26.7167 42.7704 26.3433 43.2915 26.4041C43.8126 26.4648 44.186 26.9367 44.1253 27.4578L42.5857 40.6683C42.525 41.1894 42.0531 41.5628 41.532 41.5021C41.0109 41.4413 40.6375 40.9695 40.6983 40.4484L42.2378 27.2378ZM36.5761 26.578C36.6368 26.0569 37.1087 25.6835 37.6298 25.7442C38.1509 25.805 38.5243 26.2769 38.4636 26.798L36.924 40.0085C36.8633 40.5296 36.3914 40.903 35.8703 40.8423C35.3492 40.7815 34.9758 40.3097 35.0365 39.7885L36.5761 26.578ZM30.9144 25.9182C30.9751 25.3971 31.447 25.0237 31.9681 25.0844C32.4892 25.1452 32.8626 25.617 32.8019 26.1381L31.2623 39.3487C31.2016 39.8698 30.7297 40.2432 30.2086 40.1824C29.6875 40.1217 29.3141 39.6498 29.3748 39.1287L30.9144 25.9182Z"
        fill="#CA2C26"
      />
      <path
        d="M26.1146 15H11.5348C5.83412 15 2 18.9274 2 24.769V38.2526C2 44.0777 5.83412 48.0034 11.5348 48.0034H26.1146C31.8153 48.0034 35.6326 44.0777 35.6326 38.2526V24.769C35.6326 18.9274 31.8153 15 26.1146 15Z"
        fill="#CA2C26"
        fillOpacity="0.06"
      />
      <path
        d="M25.7077 35.8204C26.4492 36.548 26.4492 37.7252 25.7077 38.4507C25.3369 38.8145 24.8571 39.0093 24.3554 39.0093C23.8756 39.0093 23.3958 38.8381 23.025 38.4507L19.1428 34.6647L15.2606 38.4507C14.8898 38.8145 14.41 39.0093 13.9084 39.0093C13.4286 39.0093 12.9269 38.8145 12.5562 38.4507C11.8146 37.7252 11.8146 36.548 12.5562 35.799L16.4384 32.0108L12.5562 28.1991C11.8146 27.4735 11.8146 26.275 12.5562 25.5474C13.2977 24.8175 14.4973 24.8175 15.2606 25.5474L19.1428 29.3548L23.0032 25.5474C23.7666 24.8175 24.9661 24.8175 25.7077 25.5474C26.4492 26.275 26.4492 27.4735 25.7077 28.1991L21.8255 32.0108L25.7077 35.8204Z"
        fill="url(#paint1_linear_143_23800)"
      />
      <defs>
        <linearGradient
          id="paint1_linear_143_23800"
          x1="25.2525"
          y1="27.5298"
          x2="9.3646"
          y2="28.0572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default RemoveIcon;
